import { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { KTSVG } from '../../../_metronic/helpers'
import { useDeleteReceiptByIdMutation } from '../../../services/InvoiceDataDraftApi'
import tosterKey from '../../localization//toster.json'
import labelKey from '../../localization/label.json'
import { useReadDraftInvoicesMutation } from '../../../services/BackgroundJobApi'
type Props = {
    show: boolean
    handleClose: () => void
    data?: any
}
const RetryInvoiceModal = ({ show, handleClose, data }: Props) => {
    const [retryAttachment, { data: retryReceiptData, isSuccess, isError, error, isLoading }] = useReadDraftInvoicesMutation();

    const handleRetryReceipt = async (data: any) => {
        await retryAttachment({ fileId: data })
    };

    useEffect(() => {
        if (isSuccess) {
            const responseData = (retryReceiptData as any)?.message;
            const successMessage = responseData;
            toast.success(successMessage);
            handleClose()
        }
    }, [isSuccess, retryReceiptData]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
            handleClose()
        }
    }, [isError, error]);
    return (
        <>
            <Modal
                aria-hidden='true'
                dialogClassName='modal-dialog modal-md modal-dialog-centered'
                show={show}
                onHide={handleClose}
            >
                <div className='modal-header bg-light py-4'>
                    <h2 className='mb-0'>{labelKey.retryAttachment}</h2>
                    {/* begin::Close */}
                    <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
                        <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                    </div>
                    {/* end::Close */}
                </div>


                <div className='modal-body py-lg-6 px-lg-6'>

                    <p className='fs-5 fw-semibold'>{labelKey.AreYouSureYouWantToRetrySubmittingThe} <span className='text-info'>"{labelKey.receipt}"</span>.</p>
                </div>
                <div className='modal-footer justify-content-center py-4'>
                    <button className='btn btn-light' onClick={handleClose}>{labelKey.cancel}</button>
                    <button
                        type='submit'
                        id='kt_sign_up_submit'
                        className='btn btn-primary'
                        onClick={() => handleRetryReceipt(data)}

                    >{isLoading ? (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            {labelKey.pleaseWait}...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                    ) : (<>{labelKey.yes}</>)}

                    </button>
                </div>
            </Modal>
        </>
    )
}

export default RetryInvoiceModal